module.exports = "<div class=\"box\">\r\n    <div *ngIf=\"pageContent\" [innerHTML]=\"pageContent | dkSafeHtml\">\r\n    </div>\r\n</div>\r\n";